import React from 'react';
import BottomSheetLocationPicker from 'Components/BottomSheetLocationPicker';
import { Controller } from 'react-hook-form'

const BottomSheetLocationPickerInput = (props: any) => {
    return (
        <React.Fragment>
            <Controller
                name={props.name}
                control={props.control}
                rules={{
                    validate: (e) => {
                        if (props?.rules['required'] == true) {
                            let message = ""
                            if (props.withLatLng) {
                                if (!e?.latitude)
                                    message += "latitude,"

                                if (!e?.longitude)
                                    message += "longitude,"
                            }

                            if (props.withAddress) {
                                if (!e?.address)
                                    message += "address,"
                            }

                            return message == "" ? true : message
                        } else
                            return true
                    }
                }}
                render={({ field: { onChange, value },
                    fieldState: { error },
                    formState }) => {
                    return <BottomSheetLocationPicker
                        onChange={onChange} value={value} {...props}
                    />;
                }} />
        </React.Fragment>
    )
}

export default BottomSheetLocationPickerInput;